"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _Button = _interopRequireDefault(require("../../../Buttons/Button"));
var _index = require("../../../index");
var _helpers = require("../../../helpers");
var _excluded = ["userInitials", "automationHook", "triggerText", "isOpen"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var avatarWidth = "30px";
var UserInitials = _styledComponents["default"].div.withConfig({
  displayName: "HeaderButton__UserInitials",
  componentId: "sc-1dxjach-0"
})(["display:flex;flex:0 0 auto;justify-content:center;align-items:center;width:", ";height:", ";border-radius:50%;overflow:hidden;background:", ";color:", ";"], avatarWidth, avatarWidth, function (props) {
  return props.theme.colors.inputIcon;
}, function (props) {
  return props.theme.colors.textInverted;
});
var Trigger = (0, _styledComponents["default"])(_Button["default"]).attrs(function (props) {
  return {
    h: "fieldsHeight",
    variant: props.variant || "border",
    color: props.color || "border",
    textColor: props.textColor || "text"
  };
}).withConfig({
  displayName: "HeaderButton__Trigger",
  componentId: "sc-1dxjach-1"
})(["display:flex;justify-content:space-between;align-items:center;min-width:82px;border-radius:20px;gap:", ";", " ", ";&:hover,&:focus{", "{background:", ";color:", ";}}"], function (props) {
  return props.theme.spaces.xs;
}, function (props) {
  return props.maxW && (0, _styledComponents.css)(["max-width:", ";"], props.maxW);
}, function (props) {
  return props.withAvatar && (0, _styledComponents.css)(["padding-left:calc((", " - ", ") / 2);"], props.theme.fields.height, avatarWidth);
}, UserInitials, function (props) {
  return (0, _helpers.darkenSafe)(0.1, props.theme.colors.inputIcon);
}, function (props) {
  return (0, _helpers.darkenSafe)(0.1, props.theme.colors.textInverted);
});
var propTypes = {
  /** User initials */
  userInitials: _propTypes["default"].string,
  /** Text for the button that opens the tooltip card */
  triggerText: _propTypes["default"].string,
  /**Hook used for automation testing. For  HeaderIconButton the suffix 'icon-button' is added*/
  automationHook: _propTypes["default"].string,
  /** This prop controls the rotation of triangle icon to be in sync with popover state*/
  isOpen: _propTypes["default"].bool
};
var HeaderButton = function HeaderButton(_ref) {
  var userInitials = _ref.userInitials,
    automationHook = _ref.automationHook,
    triggerText = _ref.triggerText,
    isOpen = _ref.isOpen,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Trigger, _extends({
    automationHook: automationHook,
    withAvatar: userInitials
  }, rest), userInitials && /*#__PURE__*/_react["default"].createElement(UserInitials, (0, _automationHooks.hook)(automationHook, "user-initials"), userInitials.toUpperCase()), /*#__PURE__*/_react["default"].createElement(_index.Text, {
    truncate: true
  }, triggerText), /*#__PURE__*/_react["default"].createElement(_index.Icon, {
    name: "TriangleDown",
    rotate: isOpen ? "180" : ""
  }));
};
HeaderButton.propTypes = propTypes;
var _default = HeaderButton;
exports["default"] = _default;